import React, { PropsWithChildren, useState } from "react";
import { IDetailsContentCollapsible } from "@interfaces/Components";
import * as ProgramUtils from "@utils/programUtils";
import Collapsible from "react-collapsible";
import classNames from "classnames";
import { useRecoilValueLoadable } from "recoil";
import { IUser } from "@interfaces/Interfaces";
import { userAtom } from "@state/State";

const DetailsContentCollapsible = (props: PropsWithChildren<IDetailsContentCollapsible>) => {
  const user = useRecoilValueLoadable<IUser | null>(userAtom);

  const [isOpen, setIsOpen] = useState(false);

  const showTrustLabel = ProgramUtils.showTrustLabelForDetailsCollapsible(props.program.ID);

  function getBackgroundColor() {
    return ProgramUtils.getTrustBackgroundColor(props.program.ID);
  }

  return (
    <Collapsible
      onOpening={() => setIsOpen(true)}
      onClosing={() => setIsOpen(false)}
      trigger={
        <>
          <div className="flex">
            {showTrustLabel && (
              <div
                className={classNames("rounded-[2px] px-1 text-13px font-semibold text-white", getBackgroundColor())}
              >
                {props.program.TrustName ?? "XXX"}
              </div>
            )}
            {props.program.showBetaLabel && (
              <div className="ml-auto rounded-[2px] bg-black px-1 text-13px font-semibold text-white">{"BETA"}</div>
            )}
          </div>
          <div className="mt-2 flex items-center justify-between">
            <div>
              <div className="text-acc-17px font-extrabold leading-normal tracking-default text-grey-80">
                {props.title}
              </div>
              {props.subTitle ? (
                <div className="text-acc-11px font-medium leading-[1.27] text-grey-60">{props.subTitle}</div>
              ) : (
                <div className="text-acc-11px font-medium leading-[1.27] text-grey-60">
                  {user && user.state === "hasValue" ? user.contents?.email! : ""}
                </div>
              )}
            </div>
            <div className="acc-underline text-[13px] font-semibold tracking-[-0.05px] text-cta-blue">
              {`${isOpen ? "Hide" : "View"} details`}
            </div>
          </div>
        </>
      }
    >
      {props.children}
    </Collapsible>
  );
};

export default DetailsContentCollapsible;
